<template>
<div class="product-template">
	<div class="product-template-image"> <img :src="'https://radap.ir/'+props.productDetail.image_url"  /> </div>
	<div class="product-template-info"> 
		<div class="p-2">
		<h3>{{props.productDetail.stuff_name}}</h3>
		<br />
		<h6 class="text-muted">{{props.productDetail.description}}</h6>
		<p v-if="props.productDetail.discount > 0" class="mb-0"> 
			<span class="item_price pt-2">
				<div class="d-flex align-items-center">
					<del class="d-block">{{PersianNumber(props.productDetail.price)}}</del>
					<label class="text-danger mr-1 product-discount" :class="{'peculiar-discount' : props.productDetail.discount > 4}">%{{PersianNumber(props.productDetail.discount)}}</label> 
				</div> 
				<strong>

					{{PersianNumber(addCommas((parseInt(props.productDetail.price.replaceAll(',','') ) - (parseInt(props.productDetail.price.replaceAll(',','')) * (parseInt(props.productDetail.discount) / 100)))))}} 
				</strong>
			</span> 
			تومان 
		</p>
		<p v-else class="mb-0 pt-2"> 
			<strong class="item_price">{{PersianNumber(props.productDetail.price)}}</strong> تومان 
		</p>
	</div>
	<div style="position: relative !important;width:11em">
		<button-template :id="props.productDetail.id" :sid="props.productDetail.store_place_id" :flag="`single`" :quantity="props.productDetail.quantity" origin="product"/>
	</div>
	</div>
</div>
</template>

<script setup>
import ButtonTemplate from '../../item/button.vue';
import defineProps from 'vue'
let props = defineProps(['productDetail'])
function PersianNumber(t){for(t=t.toString();t.search("0")>-1;)t=t.replace("0","۰");for(;t.search("1")>-1;)t=t.replace("1","۱");for(;t.search("2")>-1;)t=t.replace("2","۲");for(;t.search("3")>-1;)t=t.replace("3","۳");for(;t.search("4")>-1;)t=t.replace("4","۴");for(;t.search("5")>-1;)t=t.replace("5","۵");for(;t.search("6")>-1;)t=t.replace("6","۶");for(;t.search("7")>-1;)t=t.replace("7","۷");for(;t.search("8")>-1;)t=t.replace("8","۸");for(;t.search("9")>-1;)t=t.replace("9","۹");return t}
function addCommas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");}
</script>

<style scoped>
h3,h6,p{
	font-family: IranSans;
}
.fl-right{
	float:right;
}
.hZkLjq{
	    position: inherit !important;
		display: block;
}
.occasion-cart{
	position: relative !important;
	margin-bottom: 60px;
    height: 0px;

}

@media (max-width:426px) {
	.product-template-info{
		align-items: start !important;
		flex-direction: column !important;
	}
}

.product-template-info{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.product-template-image > img{
	border-radius: .5em;
	width: 425px;
}
.product-template-image{

	text-align: center
}
.product-discount{
    border: 1px solid red;
    line-height: 1.1;
    font-size: 12px;
    font-weight: 700;
    border-radius: 4px;
	background: red !important;
	color: white !important;
	font-family: 'IranSans';
}
</style>